(function () {
    'use strict';
    angular
        .module('invoices')
        .controller('InvoicePaymentListController', InvoicePaymentListController);
    InvoicePaymentListController.$inject = ['$location', '$filter', '$uibModal', '$state', '$stateParams', 'InvoicesService','$scope','$timeout'];
    function InvoicePaymentListController($location, $filter, $uibModal, $state, $stateParams, InvoicesService,$scope, $timeout) {
        var vm = this;
        vm.invoiceId = '';
        vm.customerName = '';
        vm.status = {id : 0, name : 'Not paid'};
        vm.query = [];
        vm.statusList = [{id : -1, name : '--- All ---'}, {id : 0, name : 'Not paid'}, {id : 1, name : 'Paid'}];
        vm.dueDate = {startDate: null, endDate: null};
        vm.paymentDate = {startDate: null, endDate: null};
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };
        vm.getInvoiceStatusLabel      = getInvoiceStatusLabel;
        vm.getInvoiceStatusClass      = getInvoiceStatusClass;
        vm.getInvoices                = getInvoices;
        vm.clear                      = clear;
        vm.openInvoice                = openInvoice;
        vm.openEditInvoiceModal       = openEditInvoiceModal;
        vm.openReversalInvoiceModal   = openReversalInvoiceModal;
        vm.remove                     = remove;
        vm.approvePaymentModal        = approvePaymentModal;
        vm.viewInvoicePaymentsModal   = viewInvoicePaymentsModal;
        vm.approveWriteOff            = approveWriteOff;

        vm.selectOptionAll = [{
            name: '--- All ---'
        }];
        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems;
        vm.currentPage;
        vm.itemsPerPage;
        vm.page = 1;


        activate();

        function activate() {
            vm.getInvoices();            
            $scope.$on('ApproveInvoicePayment', function(evt, args) {
                $timeout(function(){
                    vm.invoiceList = vm.invoiceList.map(function(item) {
                        if(item.id == args.message.id) {
                            item.status = 'Paid';
                        }
                    });
                },0);
            });
        }

        function getInvoices() {
            var query = {};

            query['paginate'] = 20;
            if (vm.customerName !== '') {
                query['company_name'] = vm.customerName;
            }
            if (vm.status.id > -1) {
                query['status'] = vm.status.id;
            }
            if (vm.invoiceId !== '' && vm.invoiceId !== null) {
                query['control_id'] = vm.invoiceId;
            }
            if ((vm.dueDate.startDate !== null ) && (vm.dueDate.endDate !== null)) {
                query['due_date'] = vm.dueDate;
                //query['due_date_end'] = vm.dueDate.endDate;
            }
            if (vm.paymentDate.startDate !== null && vm.paymentDate.endDate !== null) {
                query['payment_date'] = vm.paymentDate;
                //query['payment_date_end'] = vm.paymentDate.endDate;
            }
            if (vm.writtenOff || (typeof $location.search().writeoff !== 'undefined')) {
                query['write_off'] = 1;
            }
            if (typeof $location.search().writeoff !== 'undefined') {
                query['control_id'] = $location.search().writeoff;
            }

            query['page'] = vm.page;
            query['with'] = 'invoice_payments';
            InvoicesService.getInvoicesByFilter(query).then(function(response) {
                vm.invoices = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
                vm.approveWriteOff();
            }).catch(function(err) {
            });
        }

        function clear() {
            vm.dueDate = {startDate: null, endDate: null};
            vm.paymentDate = {startDate: null, endDate: null};
            vm.status = {id : -1, name : '--- All ---'};
            vm.invoiceId = '';
            vm.customerName = '';
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getInvoices();
        }

        function getInvoiceStatusLabel(status, due_date) {
            if (status === 'paid') {
                return 'Paid';
            } else {
                var now = new Date();
                due_date = new Date(due_date);
                if (now > due_date) {
                    return 'Overdue';
                }
            }
            return 'Waiting Payment';
        }

        function getInvoiceStatusClass(status, due_date) {
            if (status === 'paid') {
                return 'label-success';
            } else {
                var now = new Date();
                due_date = new Date(due_date);
                if (now > due_date)
                    return 'label-danger';
            }
            return 'label-warning';
        }

        function remove(invoice) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this invoice?')
                .set('onok', function (){
                    InvoicesService.destroy(invoice.id).then(function() {
                        vm.invoices.splice(vm.invoices.indexOf(invoice), 1);
                        alertify.notify('Invoice removed', 'success', 3);
                    });
                })
                .show();
        }
        function openInvoice(invoice) {
            $uibModal.open({
                templateUrl: 'templates/invoices/invoice-payment/openInvoiceModal/openInvoiceModal.html',
                controller: 'OpenInvoiceModalController',
                controllerAs:'invoiceModal',
                size: 'lg',
                resolve:
                    {
                        invoice : function () {
                            return invoice;
                        },
                        getInvoices : function() {
                            return vm.getInvoices;
                        }
                    }
            });

        }

        function openEditInvoiceModal(invoice) {
            $uibModal.open({
                templateUrl: 'templates/invoices/invoice-payment/editInvoiceModal/editInvoiceModal.html',
                controller: 'EditInvoiceModalController',
                controllerAs:'EditInvoiceModal',
                resolve:
                    {
                        invoice : function () {
                            return invoice;
                        },
                        getInvoices : function() {
                            return vm.getInvoices;
                        }
                    }
            });
        }
        function openReversalInvoiceModal(invoice) {
            $uibModal.open({
                templateUrl: 'templates/invoices/invoice-payment/reversalInvoiceModal/reversalInvoiceModal.html',
                controller: 'ReversalInvoiceModalController',
                controllerAs:'ReversalInvoiceModal',
                resolve:
                    {
                        invoice : function () {
                            return invoice;
                        },
                        getInvoices : function() {
                            return vm.getInvoices;
                        }
                    }
            });
        }

        function approvePaymentModal(invoice) {
            $uibModal.open({
                templateUrl: 'templates/invoices/invoice-payment/approvePaymentModal/approvePaymentModal.html',
                controller: 'ApprovePaymentModalController',
                controllerAs:'ApprovePaymentModal',
                resolve:
                    {
                        invoice : function () {
                            return invoice;
                        },
                        invoiceList : function () {
                            return vm.invoices;
                        }
                    }
            });
        }

        function viewInvoicePaymentsModal(invoice) {
            $uibModal.open({
                templateUrl: 'templates/invoices/invoice-payment/viewPaymentsModal/viewPaymentsModal.html',
                controller: 'ViewPaymentsModalController',
                controllerAs:'viewPaymentsModal',
                size: 'lg',
                resolve:
                    {
                        invoice : function () {
                            return invoice;
                        },
                        getInvoices : function() {
                            return vm.getInvoices;
                        }
                    }
            });

        }

        function approveWriteOff() {            
            if(typeof $location.search().writeoff !== 'undefined') {
                let invoice = $filter('filter')(vm.invoices, {control_id: $location.search().writeoff})[0];
                vm.approvePaymentModal(invoice);
            }
        }
    }
})();